import { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Alert,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import { logger } from "../../utils/logger";

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    logger.info("Forgot Password form opened");
    return () => {
      logger.info("Forgot Password form closed");
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    try {
      // Send current frontend URL dynamically
      const frontendUrl = window.location.origin;
      await axiosInstance.post("/api/auth/forgot-password", {
        email,
        frontendUrl,
      });
      setMessage("Reset link sent to your email.");
      logger.info("Forgot password link sent to email successfully", {
        email: email,
      });
    } catch (err) {
      setError(err.response?.data?.message || "Error sending reset link");
      logger.error("Forgot password request failed", {
        email: email,
        error: err,
      });
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Paper elevation={3} sx={{ p: 4, width: "100%", borderRadius: 2 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Forgot Password
        </Typography>
        <Typography
          variant="body2"
          align="center"
          sx={{ mb: 2, color: "text.secondary" }}
        >
          Enter your registered email address. We'll send you a link to reset
          your password.
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
          <Box sx={{ mt: 2 }}>
            <Button type="submit" fullWidth variant="contained" color="primary">
              Send Reset Link
            </Button>
          </Box>
          {message && (
            <Alert severity="success" sx={{ mt: 2 }}>
              {message}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </form>
        {/* Login link */}
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <Link
            to="/login"
            style={{
              textDecoration: "none",
              color: "#1976d2",
              fontSize: "0.95rem",
            }}
          >
            Back to Login
          </Link>
        </Box>
      </Paper>
    </Container>
  );
}
